export default __webpack_public_path__ + "static/media/dashboard.de51dc63.svg";